import { gql } from "@apollo/client"

export const ENTERPRISE = gql`
  query ReportEnterprise($role_id: Int!, $enterprise_id: String!) {
    ReportEnterprise(role_id: $role_id, enterprise_id: $enterprise_id) {
      enterprise_id
      enterprise_name
    }
  }
`

export const ORGANIZATION = gql`
  query ReportOrganization(
    $role_id: Int!
    $organization_id: String!
    $enterprise_id: String!
  ) {
    ReportOrganization(
      role_id: $role_id
      organization_id: $organization_id
      enterprise_id: $enterprise_id
    ) {
      organization_id
      organization_name
      enterprise_id
    }
  }
`

export const LOCATION = gql`
  query ReportLocation($organization_id: String!) {
    ReportLocation(organization_id: $organization_id) {
      organization_id
      location_id
      location_name
    }
  }
`

export const PROGRAM = gql`
  query ReportProgram($organization_id: String!) {
    ReportProgram(organization_id: $organization_id) {
      organization_id
      program_identity_id
      program_id_name
    }
  }
`

export const STATUS = gql`
  query ReportStatus($organization_id: String!) {
    ReportStatus(organization_id: $organization_id) {
      organization_id
      participant_membership_status
    }
  }
`

export const STAFF = gql`
  query ReportStaff($organization_id: String!) {
    ReportStaff(organization_id: $organization_id) {
      organization_id
      staff
      staff_id
    }
  }
`

export const TEMPLATE = gql`
  query ReportTemplate($organization_id: String!, $report_type: String!) {
    ReportTemplate(
      organization_id: $organization_id
      report_type: $report_type
    ) {
      template_title
    }
  }
`

export const BLOCK = gql`
  query ReportBlock(
    $organization_id: String!
    $template_title: String!
    $report_type: String!
  ) {
    ReportBlock(
      organization_id: $organization_id
      template_title: $template_title
      report_type: $report_type
    ) {
      block_name
      template_title
    }
  }
`

export const COLUMN = gql`
  query ReportColumn(
    $organization_id: String!
    $template_title: String!
    $block_name: String!
    $report_type: String!
  ) {
    ReportColumn(
      organization_id: $organization_id
      template_title: $template_title
      block_name: $block_name
      report_type: $report_type
    ) {
      template_title
      block_name
      field_name
    }
  }
`

export const CUSTOM_COLUMN = gql`
  query ReportCustomColumn($table_name: String!) {
    ReportCustomColumn(table_name: $table_name) {
      column_name
    }
  }
`

export const ISR = gql`
  query ReportISR(
    $organization_name: String!
    $location_id: String!
    $program_id: String!
    $start_date: String!
    $end_date: String!
    $staff: String!
    $facilitating_staff: String
    $columns: [String!]
  ) {
    ReportISR(
      organization_name: $organization_name
      location_id: $location_id
      program_id: $program_id
      start_date: $start_date
      end_date: $end_date
      staff: $staff
      facilitating_staff: $facilitating_staff
      columns: $columns
    ) {
      jobId
      reportName
      isAsync
      results {
        enterprise_name
        session_id
        participant_alias_id
        participant_membership_id
        facilitating_staff_alias_id
        facilitating_staff_name_first
        facilitating_staff_name_last
        facilitating_staff_name
        organization_alias_id
        organization_name
        organization_location
        session_location
        external_id
        program_id
        session_program_ids
        participant_name_first
        participant_name_last
        participant_email_account
        participant_phone_primary
        participant_birthdate
        age
        participant_membership_status
        participant_intake_date
        participant_last_engagement
        participant_race
        participant_hispanic_ethnicity
        participant_gender
        participant_address
        participant_city
        participant_state
        participant_zipcode
        participant_county_primary
        assigned_staff_id
        assigned_staff_name_first
        assigned_staff_name_last
        assigned_staff_name
        fee_service
        participant_ssn
        session_type
        session_date
        session_time_start
        session_time_end
        session_length
        session_units
        session_channel
        contact_successful
        insurance_current
        insurance_name
        insurance_id
        case_notes
        plan_goals_complete
        plan_goals_active
        plan_goals_future
        outcomes_collected
        recurrence_number
        overdose_number
        overdose_naloxone_reported
        overdose_911_reported
        overdose_risk_reported
        er_visits_number
        er_visits_su_mh_number
        naloxone_others_number
        arrests_number
        meetings_number
        prosocial_number
        advocacy_number
        educational_number
        engage_friends_rating
        engage_family_rating
        engage_community_rating
        physical_health_rating
        mental_health_rating
        qol_rating
        services_satisfaction_rating
        self_satisfaction_rating
        referral_made
        barc_10_score
        session_worked_on_goals
        session_appointment
        session_appointment_physical_health
        session_appointment_mental_health
        session_appointment_medications_sud
        session_appointment_counseling_sud
        session_infectious_disease_appointment
        session_appointment_child_welfare
        session_appointment_legal
        session_appointment_housing
        session_appointment_justice_system
        session_appointment_other
        session_appointment_other_type
        session_harm_reduction
        session_harm_reduction_strategy
        session_harm_reduction_infection_discussion
        session_harm_reduction_other
        session_harm_reduction_other_type
        session_physical_health_discussion
        session_mental_health_discussion
        session_crisis_support
        session_recovery_group_attendance
        session_recurrence_discussion
        session_family_support
        session_insurance_help
        session_documents_help
        session_housing_help
        session_food_help
        session_employment_needs
        session_transportation
        session_financial_verification
        session_cultural_barriers_resources
        session_activity_other
        session_activity_other_type
        session_products_supplies
        session_products_supplies_cell_phone
        session_products_supplies_clothing
        session_products_supplies_feminine_hygiene
        session_products_supplies_fentanyl_test
        session_products_supplies_food_nutritional
        session_products_supplies_gift_card
        session_products_supplies_hygiene
        session_products_supplies_naloxone_kit
        session_products_supplies_parenting
        session_products_supplies_prepaid_phone
        session_products_supplies_public_transportation
        session_products_supplies_rapid_hcv
        session_products_supplies_rapid_hiv
        session_products_supplies_safer_use
        session_products_supplies_mailing
        session_products_supplies_sterile_syringes
        session_products_supplies_other
        session_products_supplies_other_type
        care_coordination
        care_support_employment
        care_support_housing
        care_court_appearance
        care_assistance_appointment
        care_assistance_voucher
        care_record_review
        care_assistance_general_application
        care_assistance_medicaid_application
        care_assistance_medicare_application
        care_assistance_transportation
        care_assistance_financial
        care_planning_discharge
        care_personal_documents
        care_coordination_other
        care_coordination_other_type
        report_date
      }
    }
  }
`

export const ISR_GROUP_SESSION = gql`
  query ReportISRGroupSession(
    $organization_name: String!
    $location_id: String!
    $program_id: String!
    $start_date: String!
    $end_date: String!
    $staff: String!
    $facilitating_staff: String
    $columns: [String!]
  ) {
    ReportISRGroupSession(
      organization_name: $organization_name
      location_id: $location_id
      program_id: $program_id
      start_date: $start_date
      end_date: $end_date
      staff: $staff
      facilitating_staff: $facilitating_staff
      columns: $columns
    ) {
      jobId
      reportName
      isAsync
      results {
        enterprise_name
        session_id
        participant_alias_id
        participant_membership_id
        facilitating_staff_alias_id
        facilitating_staff_name_first
        facilitating_staff_name_last
        facilitating_staff_name
        organization_alias_id
        organization_name
        organization_location
        session_location
        external_id
        program_id
        session_program_ids
        participant_name_first
        participant_name_last
        participant_email_account
        participant_phone_primary
        participant_birthdate
        age
        participant_membership_status
        participant_intake_date
        participant_last_engagement
        participant_race
        participant_hispanic_ethnicity
        participant_gender
        participant_address
        participant_city
        participant_state
        participant_zipcode
        participant_county_primary
        assigned_staff_id
        assigned_staff_name_first
        assigned_staff_name_last
        assigned_staff_name
        fee_service
        participant_ssn
        session_type
        session_date
        session_time_start
        session_time_end
        session_length
        session_units
        session_channel
        contact_successful
        insurance_current
        insurance_name
        insurance_id
        case_notes
        session_topics
        session_topic_other_type
        plan_goals_complete
        plan_goals_active
        plan_goals_future
        outcomes_collected
        recurrence_number
        overdose_number
        overdose_naloxone_reported
        overdose_911_reported
        overdose_risk_reported
        er_visits_number
        er_visits_su_mh_number
        naloxone_others_number
        arrests_number
        meetings_number
        prosocial_number
        advocacy_number
        educational_number
        engage_friends_rating
        engage_family_rating
        engage_community_rating
        physical_health_rating
        mental_health_rating
        qol_rating
        services_satisfaction_rating
        self_satisfaction_rating
        referral_made
        barc_10_score
        session_worked_on_goals
        session_appointment
        session_appointment_physical_health
        session_appointment_mental_health
        session_appointment_medications_sud
        session_appointment_counseling_sud
        session_infectious_disease_appointment
        session_appointment_child_welfare
        session_appointment_legal
        session_appointment_housing
        session_appointment_justice_system
        session_appointment_other
        session_appointment_other_type
        session_harm_reduction
        session_harm_reduction_strategy
        session_harm_reduction_infection_discussion
        session_harm_reduction_other
        session_harm_reduction_other_type
        session_physical_health_discussion
        session_mental_health_discussion
        session_crisis_support
        session_recovery_group_attendance
        session_recurrence_discussion
        session_family_support
        session_insurance_help
        session_documents_help
        session_housing_help
        session_food_help
        session_employment_needs
        session_transportation
        session_financial_verification
        session_cultural_barriers_resources
        session_activity_other
        session_activity_other_type
        session_products_supplies
        session_products_supplies_cell_phone
        session_products_supplies_clothing
        session_products_supplies_feminine_hygiene
        session_products_supplies_fentanyl_test
        session_products_supplies_food_nutritional
        session_products_supplies_gift_card
        session_products_supplies_hygiene
        session_products_supplies_naloxone_kit
        session_products_supplies_parenting
        session_products_supplies_prepaid_phone
        session_products_supplies_public_transportation
        session_products_supplies_rapid_hcv
        session_products_supplies_rapid_hiv
        session_products_supplies_safer_use
        session_products_supplies_mailing
        session_products_supplies_sterile_syringes
        session_products_supplies_other
        session_products_supplies_other_type
        care_coordination
        care_support_employment
        care_support_housing
        care_court_appearance
        care_assistance_appointment
        care_assistance_voucher
        care_record_review
        care_assistance_general_application
        care_assistance_medicaid_application
        care_assistance_medicare_application
        care_assistance_transportation
        care_assistance_financial
        care_planning_discharge
        care_personal_documents
        care_coordination_other
        care_coordination_other_type
        report_date
      }
    }
  }
`

export const ORGANIZATION_REPORTS = gql`
  query ReportOrganizationReports(
    $organization_id: String!
    $template_title: String!
    $block_name: String!
    $columns: String!
    $report_type: String!
    $start_date: String!
    $end_date: String!
    $location_id: String!
    $program_id: String!
    $status: String!
    $staff: String!
    $facilitating_staff: String
  ) {
    ReportOrganizationReports(
      organization_id: $organization_id
      template_title: $template_title
      block_name: $block_name
      columns: $columns
      report_type: $report_type
      start_date: $start_date
      end_date: $end_date
      location_id: $location_id
      program_id: $program_id
      status: $status
      staff: $staff
      facilitating_staff: $facilitating_staff
    ) {
      jobId
      reportName
      isAsync
      results {
        organization_name
        block_name
        participant_membership_status
        participant_assigned_locations
        participant_assigned_programs
        assigned_staff_id
        participant_membership_id
        participant_alias
        participant_name_first
        participant_name_last
        participant_email_account
        facilitating_staff_id
        facilitating_staff_alias
        facilitating_staff_alias_id
        facilitating_staff_name_first
        facilitating_staff_name_last
        session_program_ids
        session_location_ids
        session_id
        fields_json
      }
    }
  }
`

export const GPRA_COLUMN = gql`
  query ReportMicroservicesColumns($table_name: String!) {
    ReportMicroservicesColumns(table_name: $table_name) {
      column_name
    }
  }
`
export const MICROSERVICES_REPORT_OPTIONS = gql`
  query ReportMicroservicesReportOptions($enterprise_id: String!) {
    ReportMicroservicesReportOptions(enterprise_id: $enterprise_id) {
      option_name
    }
  }
`

export const GPRA_REPORTS = gql`
  query ReportGPRAReports($organization_name: String!, $program_id: String!, $columns: [String!]) {
    ReportGPRAReports(
      organization_name: $organization_name
      program_id: $program_id
      columns: $columns
    ) {
      jobId
      reportName
      isAsync
      results {
        enterprise_name
        organization_name
        organization_alias_id
        program_ID
        Org_ID
        GPRA_Record_ID
        GPRA_Interview_ID
        GPRA_Interview_Date
        StaffID
        StaffName
        GPRA_Program_ID
        Follow_up_available
        Follow_up_due
        Follow_up_closes
        ClientID
        ClientDescripTreat
        ClientDescripRecov
        GrantNo
        InterviewType
        ConductedInterview
        InterviewDate
        BirthMonth
        BirthYear
        Gender
        GenderSpec
        HispanicLatino
        EthnicCentralAmerican
        EthnicCuban
        EthnicDominican
        EthnicMexican
        EthnicPuertoRican
        EthnicSouthAmerican
        EthnicOther
        EthnicOtherSpec
        RaceBlack
        RaceWhite
        RaceAmericanIndian
        RaceAlaskaNative
        RaceAsianIndian
        RaceChinese
        RaceFilipino
        RaceJapanese
        RaceKorean
        RaceVietnamese
        RaceOtherAsian
        RaceNativeHawaiian
        RaceGuamanianChamorro
        RaceSamoan
        RaceOtherPacificIslander
        RaceOther
        RaceSpec
        LangNotEnglishAtHome
        LangNotEnglishSpoken
        LangNotEnglishSpokenSpec
        SexIdentHeterosexual
        SexIdentHomosexual
        SexIdentBisexual
        SexIdentQueerPanaQuest
        SexIdentAsexual
        SexIdentOther
        SexIdentSpec
        RelationshipStatus
        Pregnant
        Children
        ChildrenUnder18Nr
        ChildrenCustody
        ChildrenCustodyNr
        ChildrenReunited
        ChildrenReunitedNr
        MilitaryServed
        ServicesTravelTime
        AlcoholDays
        AlcoholRoute
        AlcoholOther1Days
        AlcoholOther1Route
        AlcoholOther1Spec
        AlcoholOther2Days
        AlcoholOther2Route
        AlcoholOther2Spec
        AlcoholOther3Days
        AlcoholOther3Route
        AlcoholOther3Spec
        OpioidsHeroinDays
        OpioidsHeroinRoute
        OpioidsMorphineDays
        OpioidsMorphineRoute
        OpioidsFentanylDays
        OpioidsFentanylRoute
        OpioidsDilaudidDays
        OpioidsDilaudidRoute
        OpioidsDemerolDays
        OpioidsDemerolRoute
        OpioidsPercocetDays
        OpioidsPercocetRoute
        OpioidsCodeineDays
        OpioidsCodeineRoute
        OpioidsTylenolDays
        OpioidsTylenolRoute
        OpioidsOxycoDays
        OpioidsOxycoRoute
        OpioidsNonPresMethadoneDays
        OpioidsNonPresMethadoneRoute
        OpioidsNonPresBupDays
        OpioidsNonPresBupRoute
        OpioidsOther1Days
        OpioidsOther1Route
        OpioidsOther1Spec
        OpioidsOther2Days
        OpioidsOther2Route
        OpioidsOther2Spec
        OpioidsOther3Days
        OpioidsOther3Route
        OpioidsOther3Spec
        MarijuanaDays
        MarijuanaRoute
        SynthCannDays
        SynthCannRoute
        CannOther1Days
        CannOther1Route
        CannOther1Spec
        CannOther2Days
        CannOther2Route
        CannOther2Spec
        CannOther3Days
        CannOther3Route
        CannOther3Spec
        SedativeDays
        SedativeRoute
        HypnoDays
        HypnoRoute
        BarbituratesDays
        BarbituratesRoute
        AnxioBenzoDays
        AnxioBenzoRoute
        SedHypOther1Days
        SedHypOther1Route
        SedHypOther1Spec
        SedHypOther2Days
        SedHypOther2Route
        SedHypOther2Spec
        SedHypOther3Days
        SedHypOther3Route
        SedHypOther3Spec
        CocaineDays
        CocaineRoute
        CrackDays
        CrackRoute
        CocaineOther1Days
        CocaineOther1Route
        CocaineOther1Spec
        CocaineOther2Days
        CocaineOther2Route
        CocaineOther2Spec
        CocaineOther3Days
        CocaineOther3Route
        CocaineOther3Spec
        MethamDays
        MethamRoute
        StimMedsDays
        StimMedsRoute
        StimsOther1Days
        StimsOther1Route
        StimsOther1Spec
        StimsOther2Days
        StimsOther2Route
        StimsOther2Spec
        StimsOther3Days
        StimsOther3Route
        StimsOther3Spec
        PCPDays
        PCPRoute
        MDMADays
        MDMARoute
        LSDDays
        LSDRoute
        MushroomDays
        MushroomRoute
        MescalineDays
        MescalineRoute
        SalviaDays
        SalviaRoute
        DMTDays
        DMTRoute
        HalluPsychOther1Days
        HalluPsychOther1Route
        HalluPsychOther1Spec
        HalluPsychOther2Days
        HalluPsychOther2Route
        HalluPsychOther2Spec
        HalluPsychOther3Days
        HalluPsychOther3Route
        HalluPsychOther3Spec
        InhalantsDays
        InhalantsRoute
        InhalantsOther1Days
        InhalantsOther1Route
        InhalantsOther1Spec
        InhalantsOther2Days
        InhalantsOther2Route
        InhalantsOther2Spec
        InhalantsOther3Days
        InhalantsOther3Route
        InhalantsOther3Spec
        NonPrescGhbDays
        NonPrescGhbRoute
        KetamineDays
        KetamineRoute
        BathSaltsDays
        BathSaltsRoute
        KratomDays
        KratomRoute
        KhatDays
        KhatRoute
        OtherTranqDays
        OtherTranqRoute
        OtherDownersDays
        OtherDownersRoute
        OtherSedativesDays
        OtherSedativesRoute
        OtherHypsDays
        OtherHypsRoute
        PsychActOther1Days
        PsychActOther1Route
        PsychActOther1Spec
        PsychActOther2Days
        PsychActOther2Route
        PsychActOther2Spec
        PsychActOther3Days
        PsychActOther3Route
        PsychActOther3Spec
        TobaccoDays
        TobaccoRoute
        NicotineDays
        NicotineRoute
        TobNicOther1Days
        TobNicOther1Route
        TobNicOther1Spec
        TobNicOther2Days
        TobNicOther2Route
        TobNicOther2Spec
        TobNicOther3Days
        TobNicOther3Route
        TobNicOther3Spec
        AlcMedNaltrexone
        AlcMedNaltrexoneDays
        AlcMedExtRelNaltrexone
        AlcMedExtRelNaltrexoneDays
        AlcMedDisulfiram
        AlcMedDisulfiramDays
        AlcMedAcamprosate
        AlcMedAcamprosateDays
        AlcMedNoneRcvdDiagnosed
        AlcMedNotDiagnosed
        OpMedMethadone
        OpMedMethadoneDays
        OpMedBuprenorphine
        OpMedBuprenorphineDays
        OpMedNaltrexone
        OpMedNaltrexoneDays
        OpMedExtRelNaltrexone
        OpMedExtRelNaltrexoneDays
        OpMedNoneRcvdDiagnosed
        OpMedNotDiagnosed
        StimDisContingMgmt
        StimDisContingMgmtDays
        StimDisCommReinf
        StimDisCommReinfDays
        StimDisCBT
        StimDisCBTDays
        StimDisOtherEBI
        StimDisOtherEBIDays
        StimDisNoneRcvdDiagnosed
        StimDisNotDiagnosed
        TUDNicReplace
        TUDNicReplaceDays
        TUDBupropion
        TUDBupropionDays
        TUDVarenicline
        TUDVareniclineDays
        TUDNotRcvdDiagnosed
        TUDNotDiagnosed
        Overdose
        OverdoseIntervNaloxone
        OverdoseIntervCareED
        OverdoseIntervCarePCP
        OverdoseIntervHospital
        OverdoseIntervSupervise
        OverdoseIntervOther
        OverdoseIntervSpec
        TxSUD
        TxSUDWhen
        MHDiagnosis
        DxBriefPsych
        DxDelusional
        DxSchizoaffective
        DxSchizophrenia
        DxSchizotypal
        DxSharedPsychotic
        DxUnspecPsych
        DxBipolar
        DxMajorDepRecurr
        DxMajorDepSingle
        DxManicEp
        DxPersistMood
        DxUnspecMood
        DxAgora
        DxAgoraWithPD
        DxAgoraUnspec
        DxGAD
        DxPanic
        DxPhobic
        DxSocialPhobia
        DxSpecPhobia
        DxExcoriation
        DxHoarding
        DxOCD
        DxOCDMixed
        DxAcuteStress
        DxAdjustment
        DxBodyDysmorph
        DxDissocConvers
        DxDissocID
        DxPTSD
        DxSomat
        DxEating
        DxSleep
        DxAntisocial
        DxAvoidant
        DxBorderline
        DxDependent
        DxHistrionic
        DxIntellect
        DxObsessCompulsPers
        DxOtherSpecPD
        DxParanoid
        DxPersonalityUnspec
        DxDevelopmentalDis
        DxSchizoidPD
        DxNoneOfTheAbove
        CooccurringScreen
        CooccurringScreenStatus
        CooccurringReferral
        PlanSvcCaseManagement
        PlanSvcIntensiveOutpatient
        PlanSvcInpatient
        PlanSvcOutpatient
        PlanSvcOutreach
        PlanSvcMethadone
        PlanSvcBuprenorphine
        PlanSvcNaltrexoneShortActing
        PlanSvcNaltrexoneLongActing
        PlanSvcDisulfiram
        PlanSvcAcamprosate
        PlanSvcNicotineReplacement
        PlanSvcBupropion
        PlanSvcVarenicline
        PlanSvcResidentialRehab
        PlanSvcHospitalInpatient
        PlanSvcFreeStandingRes
        PlanSvcAmbulatoryDetox
        PlanSvcAfterCare
        PlanSvcRecoverySupport
        PlanSvcOtherModalities
        PlanSvcOtherModalitesSpec
        PlanSvcScreening
        PlanSvcBriefIntervention
        PlanSvcBriefTreatment
        PlanSvcReferralTreatment
        PlanSvcAssessment
        PlanSvcTreatmentPlanning
        PlanSvcRecoveryPlanning
        PlanSvcIndividualCouns
        PlanSvcGroupCouns
        PlanSvcContingencyManagement
        PlanSvcCommunityReinforcement
        PlanSvcCBT
        PlanSvcFamilyMarriageCouns
        PlanSvcCoOccurring
        PlanSvcPharmacological
        PlanSvcHIVAIDSCouns
        PlanSvcCulturalInterventions
        PlanSvcOtherClinicalCouns
        PlanSvcOtherClinicalCounsSpec
        PlanSvcFamilyServices
        PlanSvcChildCare
        PlanSvcPreEmployment
        PlanSvcEmploymentCoaching
        PlanSvcIndividualCoord
        PlanSvcTransportation
        PlanSvcHIVAIDServicesPreExp
        PlanSvcHIVAIDSServicesPostExp
        PlanSvcHIVAIDSServicesHIVTx
        PlanSvcDrugFreeHousing
        PlanSvcHousingSupport
        PlanSvcHealthInsuranceEnrollment
        PlanSvcOtherCaseMgmt
        PlanSvcOtherCaseMgmtSpec
        PlanSvcMedicalCare
        PlanSvcAlcoholDrugTesting
        PlanSvcOBGYN
        PlanSvcHIVAIDSMedical
        PlanSvcDental
        PlanSvcHepatitisSupport
        PlanSvcOtherSTISupport
        PlanSvcOtherMedical
        PlanSvcOtherMedicalSpec
        PlanSvcContinuingCare
        PlanSvcRelapsePrevention
        PlanSvcRecoveryCoaching
        PlanSvcSelfHelpSupport
        PlanSvcSpiritualSupport
        PlanSvcOtherAfterCare
        PlanSvcOtherAfterCareSpec
        PlanSvcSubstanceAbuseEdu
        PlanSvcHIVAIDSEdu
        PlanSvcNaloxoneTraining
        PlanSvcFentanylTestStripTraining
        PlanSvcHepatitisEdu
        PlanSvcOtherSTIEdu
        PlanSvcOtherEdu
        PlanSvcOtherEduSpec
        PlanSvcPeerCoaching
        PlanSvcVocational
        PlanSvcRecoveryHousing
        PlanSvcRecoveryPlanningRSS
        PlanSvcRecoveryCaseManagement
        PlanSvcDrugFreeSocial
        PlanSvcInformationReferral
        PlanSvcOtherRecoverySupport
        PlanSvcOtherRecoverySupportSpec
        PlanSvcOtherPeerRecovery
        PlanSvcOtherPeerRecoverySpec
        LivingWhere
        LivingHoused
        LivingHousedSpec
        LivingAlcDrugUse
        SchoolOrTrainingProgram
        Education
        EmployStatus
        EmployStatusSpec
        EnoughMoneyFood
        EnoughMoneyClothing
        EnoughMoneyTransport
        EnoughMoneyRentHousing
        EnoughMoneyUtilities
        EnoughMoneyPhone
        EnoughMoneyChildcare
        EnoughMoneyHealthIns
        Income
        ArrestedDays
        Incarcerated
        AwaitTrial
        ParoleProb
        DrugCourtDeferredProsec
        LifeQuality
        Depression
        Anxiety
        Hallucinations
        BrainFunction
        ViolentBehavior
        Suicide
        PsycholEmotMedication
        PsycholEmotImpact
        ReceivedMedCarePCP
        ReceivedMedCareUrgentCare
        ReceivedMedCareED
        ReceivedMedCareSpecialist
        ReceivedMedCareNoCareSought
        ReceivedMedCareOther
        ReceivedMedCareSpec
        MedInsuranceStatus
        MedInsTypeMedicare
        MedInsTypeMedicaid
        MedInsTypePrivateOrEmployer
        MedInsTypeMilitary
        MedInsTypeAssistanceProgram
        MedInsTypeOther
        MedInsTypeSpec
        AttendVoluntary
        AttendVoluntaryTimes
        InteractFamilyFriends
        RelationshipSatisfaction
        ChangeConnectionsPlaces
        PeerSupport
        EnrolledInSchoolH8
        EnrolledInSchoolHelpH8
        EnrolledInVocTrainingH8
        EnrolledInVocTrainingHelpH8
        CurrentlyEmployedH8
        CurrentlyEmployedHelpH8
        LivingInStableHousingH8
        LivingInStableHousingHelpH8
        QualityOfLife
        FLWPClientContacted
        FLWPStatus
        FLWPStatusSpec
        ReceivingServices
        DischargeDate
        DischargeStatusCompl
        DischargeStatusTermReason
        OtherDischargeStatTermRsnSpec
        jHIVTest
        jHIVTestResult
        ODPreventionToolsProvided
        VaccinatedStatusCOVID19
        SvcCaseManagement
        SvcIntensiveOutpatient
        SvcInpatient
        SvcOutpatient
        SvcOutreach
        SvcMethadone
        SvcBuprenorphine
        SvcNaltrexoneShortActing
        SvcNaltrexoneLongActing
        SvcDisulfiram
        SvcAcamprosate
        SvcNicotineReplacement
        SvcBupropion
        SvcVarenicline
        SvcResidentialRehab
        SvcHospitalInpatient
        SvcFreeStandingRes
        SvcAmbulatoryDetox
        SvcAfterCare
        SvcRecoverySupport
        SvcOtherModalities
        SvcOtherModalitesSpec
        SvcScreening
        SvcBriefIntervention
        SvcBriefTreatment
        SvcReferralTreatment
        SvcAssessment
        SvcTreatmentPlanning
        SvcRecoveryPlanning
        SvcIndividualCouns
        SvcGroupCouns
        SvcContingencyManagement
        SvcCommunityReinforcement
        SvcCBT
        SvcFamilyMarriageCouns
        SvcCoOccurring
        SvcPharmacological
        SvcHIVAIDSCouns
        SvcCulturalInterventions
        SvcOtherClinicalCouns
        SvcOtherClinicalCounsSpec
        SvcFamilyServices
        SvcChildCare
        SvcPreEmployment
        SvcEmploymentCoaching
        SvcIndividualCoord
        SvcTransportation
        SvcHIVAIDSServices
        SvcDrugFreeHousing
        SvcHousingSupport
        SvcHealthInsuranceEnrollment
        SvcOtherCaseMgmt
        SvcOtherCaseMgmtSpec
        SvcMedicalCare
        SvcAlcoholDrugTesting
        SvcOBGYN
        SvcHIVAIDSMedical
        SvcDental
        SvcHepatitisSupport
        SvcOtherSTISupport
        SvcOtherMedical
        SvcOtherMedicalSpec
        SvcSubstanceAbuseEdu
        SvcHIVAIDSEdu
        SvcNaloxoneTraining
        SvcFentanylTestStripTraining
        SvcHepatitisEdu
        SvcOtherSTIEdu
        SvcOtherEdu
        SvcOtherEduSpec
        SvcPeerCoaching
        SvcVocational
        SvcRecoveryHousing
        SvcRecoveryPlanningRSS
        SvcRecoveryCaseManagement
        SvcDrugFreeSocial
        SvcInformationReferral
        SvcOtherRecoverySupport
        SvcOtherRecoverySupportSpec
        SvcOtherPeerRecovery
        SvcOtherPeerRecoverySpec
        AttendedMostPlannedServices
        ReceivedTelehealthServices
        PreviouslyDiagnosedOUD
        kOUDMedMethadone
        kOUDMedMethadoneDays
        kOUDMedBuprenorphine
        kOUDMedBuprenorphineDays
        kOUDMedNaltrexone
        kOUDMedNaltrexoneDays
        kOUDMedXRNaltrexone
        kOUDMedXRNaltrexoneDays
        kOUDMedNotReceived
        OUDMedTakenAsPrescribed
        PreviouslyDiagnosedAUD
        kAUDMedNaltrexone
        kAUDMedNaltrexoneDays
        kAUDMedXRNaltrexone
        kAUDMedXRNaltrexoneDays
        kAUDMedDisulfiram
        kAUDMedDisulfiramDays
        kAUDMedAcamprosate
        kAUDMedAcamprosateDays
        kAUDMedNotReceived
        AUDMedTakenAsPrescribed
        PreviouslyDiagnosedStUD
        kStUDIntContMgmt
        kStUDIntContMgmtDays
        kStUDIntCommReinf
        kStUDIntCommReinfDays
        kStUDIntCBT
        kStUDIntCBTDays
        kStUDIntOther
        kStUDIntOtherDays
        kStUDIntNotReceived
        StUDIntAttended
        PreviouslyDiagnosedTUD
        kTUDMedNicotineRepl
        kTUDMedNicotineReplDays
        kTUDMedBupropion
        kTUDMedBupropionDays
        kTUDMedVarenicline
        kTUDMedVareniclineDays
        kTUDMedNotReceived
        TUDMedTakenAsPrescribed
        BatchID
        QAOnly
        LangNotSpanishAtHome
        LangNotSpanishSpoken
        LangNotSpanishSpokenSpec
        ReunitedChild
        ReunitedChildWithAgcySupe
        ReunitedChildWithoutAgcySupe
        AvoidedOutOfHomePlacement
        H1NoneOfAbove
        HelpObPrivateHealthInsurance
        HelpObMedicaid
        HelpObMedicare
        HelpObSSIOrSSDI
        HelpObTANF
        HelpObSNAP
        HelpObOtherBenefit
        HelpObOtherBenefitSpec
        HelpObNoneOfTheAbove
        EnrolledInSchool
        EnrolledInSchoolHelp
        EnrolledInVocTraining
        EnrolledInVocTrainingHelp
        CurrentlyEmployed
        CurrentlyEmployedHelp
        LivingInStableHousing
        LivingInStableHousingHelp
        MaintainFamilyResponsibilities
        SupportToParentingAndRecovery
        EnableFocusOnTreatment
        SupportToParentingAndRecoveryH5
        CurrentSamhsaGrantFunding
        OtherFederalGrantFunding
        StateFunding
        ClientsPrivateInsurance
        MedicaidOrMedicare
        SBIRTTricare
        SBIRTOther
        SBIRTOtherSpec
        SBIRTClientScreen
        SBIRTScoreAUDIT
        SBIRTScoreCAGE
        SBIRTScoreDAST
        SBIRTScoreDAST10
        SBIRTScoreNIAAA
        SBIRTScoreASSIST
        SBIRTScoreOther
        SBIRTScoreSpec
        SBIRTContService
        BriefInterventionAssigned
        BriefTreatmentAssigned
        ReferralToTreatmentAssigned
        BriefIntervention
        BriefTreatment
        ReferralToTreatment
        SexActivity
        SexContacts
        SexUnprot
        SexUnprotectedHIV
        SexUnprotectedInjDrugUser
        SexUnprotectedHigh
        PrEPOrTreat
        HIVTestH
        HIVTestFirstTime
        HIVTestLocation
        HIVTestReferralLocation
        HIVTestReferralLocationSpec
        HIVTestResultH
        HIVTestConfirmatory
        HIVTestConfirmatoryRes
        TreatmentForHIVH
        TreatmentForHIVLocation
        TreatmentForHIVLocationSpec
        HIVTestingPartners
        HIVTestingPartnersNumber
        HIVReferredPreEP
        HIVReferredPEP
        HIVReferredCounseling
        HIVReferredNoMedications
        HIVReferredNoCounseling
        HCVTest
        HCVTestConfirmatory
        HCVTestResult
        TreatmentForHCV
        HBVTest
        HBVTestResult
        TreatmentForHBV
        HepABVacc
        HepABVaccReferral
        CommunicateWithProvider
        ReduceSubstanceUse
        ManageMentalHealthSymptoms
        SupportRecovery
        MentalHealthDisorderScreen
        MentalHealthServiceReferred
        MentalHealthServiceReceived
        CoOccurringDisorderScreen
        CoOccurringServiceReferred
        CoOccurringServiceReceived
        HelpedAvoidJusticeSystem
        SvcContinuingCare
        SvcRelapsePrevention
        SvcRecoveryCoaching
        SvcSelfHelpSupport
        SvcSpiritualSupport
        SvcOtherAfterCare
        SvcOtherAfterCareSpec
      }
    }
  }
`

export const INDIANA_OS_REPORT = gql`
  query ReportIndianaOSReport($organization_name: String!, $columns: [String!]) {
    ReportIndianaOSReport(organization_name: $organization_name, columns: $columns) {
      jobId
      reportName
      isAsync
      results {
        Organization_Name
        Number_of_Unique_Opioid_Stimulant_Participants_Served
        Opioid_Stimulant_Specific_Referrals
        Opioid_Stimulant_Specific_DOC_Referrals
        Number_of_Opioid_Stimulant_Groups_Held_Group_Sessions_Groups
        Number_of_Opioid_Stimulant_Attendees_Group_Sessions_Groups
        Number_of_Unique_Non_Opioid_Stimulant_Participants_Served
        Non_Opioid_Stimulant_Specific_Referrals
        Non_Opioid_Stimulant_Specific_DOC_Referrals
        Number_of_Non_Opioid_Stimulant_Groups_Held_Group_Sessions_Groups
        Number_of_Non_Opioid_Stimulant_Attendees_Group_Sessions_Groups
        Number_of_Unique_Mental_Health_Participants_Served
        Mental_Health_Specific_Referrals
        Mental_Health_Specific_DOC_Referrals
        Number_of_Mental_Health_Groups_Held_Group_Sessions_Groups
        Number_of_Mental_Health_Attendees_Group_Sessions_Groups
        Number_of_Unique_Co_Occurring_Participants_Served
        Co_Occurring_Specific_Referrals
        Co_Occurring_Specific_DOC_Referrals
        Number_of_Co_Occurring_Groups_Held_Group_Sessions_Groups
        Number_of_Co_Occurring_Attendees_Group_Sessions_Groups
        Report_Month
      }
    }
  }
`

export const INDIANA_ACTIVITY_SESSION_REPORT = gql`
  query ReportIndianaActivitySessionReport($organization_name: String!, $columns: [String!]) {
    ReportIndianaActivitySessionReport(organization_name: $organization_name, columns: $columns) {
      jobId
      reportName
      isAsync
      results {
        Organization_Name
        Number_of_Opioid_Stimulant_Groups_Held_Activity_Sessions_Groups
        Number_of_Opioid_Stimulant_Attendees_Activity_Sessions_Groups
        Number_of_Opioid_Stimulant_Distributions_Activity_Sessions_Groups
        Number_of_Non_Opioid_Stimulant_Groups_Held_Activity_Sessions_Groups
        Number_of_Non_Opioid_Stimulant_Attendees_Activity_Sessions_Groups
        Number_of_Non_Opioid_Stimulant_Distributions_Activity_Sessions_Groups
        Number_of_Mental_Health_Groups_Held_Activity_Sessions_Groups
        Number_of_Mental_Health_Attendees_Activity_Sessions_Groups
        Number_of_Mental_Health_Distributions_Activity_Sessions_Groups
        Number_of_Co_Occurring_Groups_Held_Activity_Sessions_Groups
        Number_of_Co_Occurring_Attendees_Activity_Sessions_Groups
        Number_of_Co_Occurring_Distributions_Activity_Sessions_Groups
        Number_of_Other_Groups_Held_Activity_Sessions_Groups
        Number_of_Other_Attendees_Activity_Sessions_Groups
        Number_of_Other_Distributions_Activity_Sessions_Groups
        Report_Month
      }
    }
  }
`

export const INDIANA_DEMOGRAPHICS_REPORT = gql`
  query ReportIndianaDemographicsReport($organization_name: String!, $columns: [String!]) {
    ReportIndianaDemographicsReport(organization_name: $organization_name, columns: $columns) {
      jobId
      reportName
      isAsync
      results {
        Organization_Name
        Organization_Name
        Gender_Female
        Gender_Male
        Gender_Trans_Female
        Gender_Trans_Male
        Gender_Gender_Fluid
        Gender_Non_Binary
        Gender_Prefer_Not_To_Answer
        Gender_Not_Listed
        Age_Under_17
        Age_17_25
        Age_26_35
        Age_36_45
        Age_46_55
        Age_56_65
        Age_Over_66
        Age_NA
        Most_Recent_Employment_Employed_Full_Time
        Most_Recent_Employment_Employed_Part_Time
        Most_Recent_Employment_On_Disability
        Most_Recent_Employment_Unemployed
        Most_Recent_Employment_Other
        Most_Recent_Employment_Student
        Most_Recent_Employment_NA
        Baseline_Employment_Employed_Full_Time
        Baseline_Employment_Employed_Part_Time
        Baseline_Employment_On_Disability
        Baseline_Employment_Unemployed
        Baseline_Employment_Other
        Baseline_Employment_Student
        Baseline_Employment_NA
        Avg_Intake_Recovery_Capital_BARC_10
        Avg_Current_Recovery_Capital_BARC_10
        Avg_Change_In_Recovery_Capital_BARC_10
        Total_Assessments_Completed
        Total_Number_of_Unique_Engagements
        Average_Engagement_Length_of_Active_Participants_in_the_Period
        Average_Engagement_Length_of_Discharged_Participants_in_the_Period
        Average_Length_of_Engagement_Sessions_in_Minutes_in_the_Period
        Physical_Health_Percent_of_Participants_Who_Responded
        Avg_Physical_Health_Rating_Most_Recent
        Avg_Physical_Health_Rating_Baseline
        Mental_Health_Percent_of_Participants_Who_Responded
        Avg_Mental_Health_Rating_Most_Recent
        Avg_Mental_Health_Rating_Baseline
        Quality_of_Life_Percent_of_Participants_Who_Responded
        Avg_Quality_of_Life_Rating_Most_Recent
        Avg_Quality_of_Life_Rating_Baseline
        Self_Satisfaction_Percent_of_Participants_Who_Responded
        Avg_Self_Satisfaction_Rating_Most_Recent
        Avg_Self_Satisfaction_Rating_Baseline
        Services_Satisfaction_Percent_of_Participants_Who_Responded
        Avg_Services_Satisfaction_Rating_Most_Recent
        Avg_Services_Satisfaction_Rating_Baseline
        Number_of_Engagement_Sessions_with_Outcomes_Collected
        Number_of_Emergency_Room_Visits_BH_Related
        Number_of_Emergency_Room_Visits_Non_BH_Related
        Number_of_Non_Emergency_Medical_Visits
        Number_of_Overdose_Event
        Number_of_Recurrences_of_Substance_Use
        Number_of_Arrested_Reported
        Report_Month
      }
    }
  }
`

export const INDIANA_DIRECT_SERVICE_REPORT = gql`
  query ReportIndianaDirectServiceReport($organization_name: String!, $columns: [String!]) {
    ReportIndianaDirectServiceReport(organization_name: $organization_name, columns: $columns) {
      jobId
      reportName
      isAsync
      results {
        Organization_Name
        Total_Direct_Service_Hours
        Report_Month
      }
    }
  }
`

export const INDIANA_ENGAGEMENT_REPORT = gql`
  query ReportIndianaEngagementReport($organization_name: String!, $columns: [String!]) {
    ReportIndianaEngagementReport(organization_name: $organization_name, columns: $columns) {
      jobId
      reportName
      isAsync
      results {
        Organization_Name
        Session_Type
        Opioid_Stimulant_Specific_Number_of_Engagements_by_Individual_Type
        Opioid_Stimulant_Specific_Percent_of_Engagements_by_Individual_Type
        Non_Opioid_Stimulant_Specific_Number_of_Engagements_by_Individual_Type
        Non_Opioid_Stimulant_Specific_Percent_of_Engagements_by_Individual_Type
        Mental_Health_Specific_Number_of_Engagements_by_Individual_Type
        Mental_Health_Specific_Percent_of_Engagements_by_Individual_Type
        Co_Occurring_Specific_Number_of_Engagements_by_Individual_Type
        Co_Occurring_Specific_Percent_of_Engagements_by_Individual_Type
        Report_Month
      }
    }
  }
`

export const INDIANA_GPRA_REPORT = gql`
  query ReportIndianaGPRAReport($organization_name: String!, $columns: [String!]) {
    ReportIndianaGPRAReport(organization_name: $organization_name, columns: $columns) {
      jobId
      reportName
      isAsync
      results {
        Organization_Name
        Number_of_GPRA_Intakes_Collected
        Number_od_GPRA_Follow_ups_Collected
        Number_of_GPRA_Discharges_Collected
        Report_Month
      }
    }
  }
`

export const INDIANA_LIST_REFERRALS_REPORT = gql`
  query ReportIndianaListofReferralsReport($organization_name: String!, $columns: [String!]) {
    ReportIndianaListofReferralsReport(organization_name: $organization_name, columns: $columns) {
      jobId
      reportName
      isAsync
      results {
        Organization_Name
        Participant_Type
        Date
        Referral_Entity
        Engagement_Channel
        Referral_Outcome
        Report_Month
      }
    }
  }
`

export const INDIANA_LYFT_DROPOFF_REPORT = gql`
  query ReportIndianaLyftDropoffReport($organization_name: String!, $columns: [String!]) {
    ReportIndianaLyftDropoffReport(organization_name: $organization_name, columns: $columns) {
      jobId
      reportName
      isAsync
      results {
        Organization_Name
        Drop_off_Location_Type
        Number_of_Rides
        Percent_of_Rides
        Report_Month
      }
    }
  }
`

export const INDIANA_LYFT_REPORT = gql`
  query ReportIndianaLyftReport($organization_name: String!, $columns: [String!]) {
    ReportIndianaLyftReport(organization_name: $organization_name, columns: $columns) {
      jobId
      reportName
      isAsync
      results {
        Organization_Name
        Number_of_Unique_Participants_Who_Had_a_LYFT_Request_Form_Completed
        Number_of_Unique_Participants_Who_Received_a_LYFT_Ride
        Number_of_Rides_for_Health
        Percent_of_Rides_for_Health
        Number_of_Rides_for_Home
        Percent_of_Rides_for_Home
        Number_of_Rides_for_Community
        Percent_of_Rides_for_Community
        Number_of_Rides_for_Purpose
        Percent_of_Rides_for_Purpose
        Report_Month
      }
    }
  }
`

export const INDIANA_SUPERVISION_REPORT = gql`
  query ReportIndianaSupervisionReport($organization_name: String!, $columns: [String!]) {
    ReportIndianaSupervisionReport(organization_name: $organization_name, columns: $columns) {
      jobId
      reportName
      isAsync
      results {
        Organization_Name
        Total_Individual_Supervision_Hours
        Total_Group_Supervision_Hours
        Report_Month
      }
    }
  }
`
export const INDIANA_CONTACT_LOG_REPORT = gql`
  query ReportIndianaContactLogReport($organization_name: String!, $columns: [String!]) {
    ReportIndianaContactLogReport(organization_name: $organization_name, columns: $columns) {
      jobId
      reportName
      isAsync
      results {
        Organization_Name
        Number_of_Contact_Logs_Completed
        Number_of_Contacts_Incoming
        Number_of_Contacts_Outgoing
        Total_Contact_Duration_Minutes
        Total_Contact_Duration_Minutes_Average
        Number_for_Care_Coordination
        Number_for_Community_Service
        Number_for_Donations
        Number_for_Family_Support_Services
        Number_for_General_Resource_Referral_and_Navigation
        Number_for_Mental_Health_Services
        Number_for_Naloxone_Use_and_Availability
        Number_for_Other_Harm_Reduction_Services
        Number_for_Recovery_Supportive_Housing
        Number_for_Recovery_Support_Services
        Number_for_Report_Overdose_Reversal
        Number_for_Safer_Use_Discussion
        Number_for_SUD_Medication_Services
        Number_for_Syringe_Service_Programs
        Number_for_Training
        Number_for_Treatment_Services_Inpatient
        Number_for_Treatment_Services_Outpatient
        Number_for_Treatment_Services_Other
        Number_for_Volunteering
        Number_for_Withdrawal_Management_Services
        Number_for_Other
        Report_Month
      }
    }
  }
`

export const INDIANA_REFERRALS_REPORT = gql`
  query ReportIndianaReferralsReport($organization_name: String!, $columns: [String!]) {
    ReportIndianaReferralsReport(organization_name: $organization_name, columns: $columns) {
      jobId
      reportName
      isAsync
      results {
        Organization_Name
        Total_Number_of_Opioid_Stimulant_Successful_Incoming_DOC_Referrals
        Total_Number_of_Opioid_Stimulant_Unsuccessful_Incoming_DOC_Referrals
        Total_Number_of_Opioid_Stimulant_Incoming_DOC_Referrals
        Total_Number_of_Non_Opioid_Stimulant_Successful_Incoming_DOC_Referrals
        Total_Number_of_Non_Opioid_Stimulant_Unsuccessful_Incoming_DOC_Referrals
        Total_Number_of_Non_Opioid_Stimulant_Incoming_DOC_Referrals
        Total_Number_of_Mental_Health_Successful_Incoming_DOC_Referrals
        Total_Number_of_Mental_Health_Unsuccessful_Incoming_DOC_Referrals
        Total_Number_of_Mental_Health_Incoming_DOC_Referrals
        Total_Number_of_Co_Occurring_Successful_Incoming_DOC_Referrals
        Total_Number_of_Co_Occurring_Unsuccessful_Incoming_DOC_Referrals
        Total_Number_of_Co_Occurring_Incoming_DOC_Referrals
        Total_Number_of_Other_Successful_Incoming_DOC_Referrals
        Total_Number_of_Other_Unsuccessful_Incoming_DOC_Referrals
        Total_Number_of_Other_Incoming_DOC_Referrals
        Report_Month
      }
    }
  }
`

export const INDIANA_ASYNC_EXPORT_STATUS = gql`
  query ReportIndianaAsyncExportStatus($job_id: String!) {
    ReportIndianaAsyncExportStatus(job_id: $job_id) {
      job_id
      mode
      status
      message
      download_url
      expires_at
      error_code
      row_count
      estimated_rows
      file_size_bytes
    }
  }
`

// Poll status after async start (report query returns isAsync + jobId) — see docs/report-async-export.md
export const REPORT_ASYNC_EXPORT_STATUS = gql`
  query ReportAsyncExportStatus($job_id: String!) {
    ReportAsyncExportStatus(job_id: $job_id) {
      job_id
      mode
      status
      message
      download_url
      download_filename
      expires_at
      error_code
      row_count
      estimated_rows
      file_size_bytes
    }
  }
`

export const PRIME_CHRACTERISTICS_REPORT = gql`
  query ReportPrimeCharacteristicsReport($organization_id: String!, $columns: [String!]) {
    ReportPrimeCharacteristicsReport(organization_id: $organization_id, columns: $columns) {
      jobId
      reportName
      isAsync
      results {
        session_id
        date_modified
        enterprise_name
        organization_id
        organization_alias_id
        organization_name
        participant_alias_id
        participant_membership_id
        facilitating_staff_id
        session_type
        block_name
        demo_children
        demo_children_minor
        demo_children_court
        demo_children_court_number
        status_sud_treatment
        status_sud_treatment_episodes
        attend_meetings
        attend_meetings_count
        history_su
        history_su_alc
        history_su_rx_opioids
        history_su_other_opioids
        demo_suhx_amphetamines
        demo_suhx_cocaine_crack
        history_su_psychedelics
        history_su_cannabis
        history_su_nicotine
        history_su_other_sub
        history_recovery_residence
        status_mh_treatment
        status_mh_treatment_episodes
        history_mh
        history_mh_depression
        history_mh_anxiety
        history_mh_schizophrenia
        history_mh_bipolar
        history_mh_eating_disorder
        history_mh_other
        history_gambling
        medication_use_current
        medication_use
      }
    }
  }
`

export const PRIME_DEMOGRAPHICS_REPORT = gql`
  query ReportPrimeDemographicsReport($organization_id: String!, $columns: [String!]) {
    ReportPrimeDemographicsReport(organization_id: $organization_id, columns: $columns) {
      jobId
      reportName
      isAsync
      results {
        session_id
        date_modified
        enterprise_name
        organization_id
        organization_alias_id
        organization_name
        participant_alias_id
        participant_membership_id
        facilitating_staff_id
        session_type
        block_name
        demo_birthdate
        demo_gender
        demo_race
        demo_ethnicity
        demo_status_housing
        demo_drug_use_past3mo
        demo_drug_use_past3mo_other
        demo_inject_drug_hx
        demo_curr_counseling
        demo_naloxone
        demo_ever_overdose
        demo_ever_overdose_date
        demo_ever_manic
        demo_ever_manic_date
        demo_curr_med
        demo_curr_med_type
        demo_curr_med_other
        demo_drug_method
        demo_drug_method_other
        demo_ever_stroke
        demo_ever_stroke_date
        custom_1668711845767
        demo_curr_pcp
        demo_status_justice
        demo_sexual_orientation
        demo_pregnancy
        demo_pregnancy_due_date
        demo_pregnancy_trimester
      }
    }
  }
`
//New PRIME
export const PRIME_INTAKES_REPORT = gql`
  query ReportPrimeIntakesReport(
    $organization_name: String!
    $location_id: String!
    $program_id: String!
    $start_date: String!
    $end_date: String!
    $staff: String!
    $columns: [String!]
  ) {
    ReportPrimeIntakesReport(
      organization_name: $organization_name
      location_id: $location_id
      program_id: $program_id
      start_date: $start_date
      end_date: $end_date
      staff: $staff
      columns: $columns
    ) {
      jobId
      reportName
      isAsync
      results {
        organization_name
        participant_alias
        participant_membership_id
        session_id
        assigned_staff_name
        facilitating_staff_name
        program_identity_names
        location_names
        consent_data_store
        consent_data_share
        intake_source
        intake_source_name
        session_date
        session_format
        session_start_time
        session_end_time
        session_length
        demo_birthdate
        demo_gender
        demo_race
        demo_ethnicity
        demo_status_housing
        insurance_type
        demo_naloxone
        demo_inject_drug_hx
        demo_curr_counseling
        demo_curr_med
        demo_curr_med_other
        demo_curr_med_type
        demo_curr_pcp
        demo_drug_use_past3mo
        demo_drug_use_past3mo_other
        demo_drug_method
        demo_drug_method_other
        demo_ever_overdose
        demo_ever_overdose_date
        demo_ever_manic
        demo_ever_manic_date
        demo_ever_stroke
        demo_ever_stroke_date
        demo_status_justice
        demo_sexual_orientation
        demo_pregnancy
        demo_pregnancy_due_date
        demo_pregnancy_trimester
        intake_supports_not_received
        intake_internet
        domain_1
        goal_1
        action_activity_1
        action_date_1
        action_status_1
        domain_2
        goal_2
        action_activity_2
        action_date_2
        action_status_2
        domain_3
        goal_3
        action_activity_3
        action_date_3
        action_status_3
        domain_4
        goal_4
        action_activity_4
        action_date_4
        action_status_4
        domain_5
        goal_5
        action_activity_5
        action_date_5
        action_status_5
        domain_6
        goal_6
        action_activity_6
        action_date_6
        action_status_6
        domain_7
        goal_7
        action_activity_7
        action_date_7
        action_status_7
        domain_8
        goal_8
        action_activity_8
        action_date_8
        action_status_8
        domain_9
        goal_9
        action_activity_9
        action_date_9
        action_status_9
        domain_10
        goal_10
        action_activity_10
        action_date_10
        action_status_10
        domain_11
        goal_11
        action_activity_11
        action_date_11
        action_status_11
        domain_12
        goal_12
        action_activity_12
        action_date_12
        action_status_12
        domain_13
        goal_13
        action_activity_13
        action_date_13
        action_status_13
        domain_14
        goal_14
        action_activity_14
        action_date_14
        action_status_14
        domain_15
        goal_15
        action_activity_15
        action_date_15
        action_status_15
        peercm_consent
        gpra_intake_date
        gpra_intake_date_6month
        incentivegroup
        incentivegroup_change
        incentivegroup_change_date
        incentivegroup_change_date_end
        incentive_1
        incentive_1date
        incentive_1peer
        incentive_2
        incentive_2date
        incentive_2peer
        incentive_3
        incentive_3date
        incentive_3peer
        incentive_4
        incentive_4date
        incentive_4peer
        incentive_5
        incentive_5date
        incentive_5peer
        incentive_6
        incentive_6date
        incentive_6peer
        incentive_7
        incentive_7date
        incentive_7peer
        incentive_8
        incentive_8date
        incentive_8peer
        incentive_9
        incentive_9date
        incentive_9peer
        incentive_10
        incentive_10date
        incentive_10peer
        incentive_11
        incentive_11date
        incentive_11peer
        incentive_12
        incentive_12date
        incentive_12peer
        incentive_13
        incentive_13date
        incentive_13peer
        incentive_14
        incentive_14date
        incentive_14peer
        incentive_15
        incentive_15date
        incentive_15peer
        activity1_incentive
        activity1_dom
        activity1_goal
        activity1_action
        activity1_date_act
        activity1_date_incent
        activity1_peer
        activity2_incentive
        activity2_dom
        activity2_goal
        activity2_action
        activity2_date_act
        activity2_date_incent
        activity2_peer
        activity3_incentive
        activity3_dom
        activity3_goal
        activity3_action
        activity3_date_act
        activity3_date_incent
        activity3_peer
        activity4_incentive
        activity4_dom
        activity4_goal
        activity4_action
        activity4_date_act
        activity4_date_incent
        activity4_peer
        activity5_incentive
        activity5_dom
        activity5_goal
        activity5_action
        activity5_date_act
        activity5_date_incent
        activity5_peer
        activity6_incentive
        activity6_dom
        activity6_goal
        activity6_action
        activity6_date_act
        activity6_date_incent
        activity6_peer
        activity7_incentive
        activity7_dom
        activity7_goal
        activity7_action
        activity7_date_act
        activity7_date_incent
        activity7_peer
        activity8_incentive
        activity8_dom
        activity8_goal
        activity8_action
        activity8_date_act
        activity8_date_incent
        activity8_peer
        activity9_incentive
        activity9_dom
        activity9_goal
        activity9_action
        activity9_date_act
        activity9_date_incent
        activity9_peer
        activity10_incentive
        activity10_dom
        activity10_goal
        activity10_action
        activity10_date_act
        activity10_date_incent
        activity10_peer
        has_hepc
        HCV_test_rapid
        hep_test_c_date
        HCV_test_rapid_result
        HCV_test_RNA
        hep_test_hcv_rna_date
        HCV_test_RNA_result
        HCV_tx_link
        HCV_tx_start
        hep_hcv_medication_date
        HCV_tx_complete
        HCV_post_tx_test
        HCV_post_tx_test_result
        hep_ab_services
        report_date
      }
    }
  }
`

export const PRIME_CHECK_INS_REPORT = gql`
  query ReportPrimeCheckInsReport(
    $organization_name: String!
    $location_id: String!
    $program_id: String!
    $start_date: String!
    $end_date: String!
    $staff: String!
    $columns: [String!]
  ) {
    ReportPrimeCheckInsReport(
      organization_name: $organization_name
      location_id: $location_id
      program_id: $program_id
      start_date: $start_date
      end_date: $end_date
      staff: $staff
      columns: $columns
    ) {
      jobId
      reportName
      isAsync
      results {
        organization_name
        participant_alias
        participant_membership_id
        session_id
        assigned_staff_name
        facilitating_staff_name
        program_identity_names
        location_names
        session_date
        session_format
        session_start_time
        session_end_time
        session_length
        session_contact_successful
        session_activities
        session_discussion_type
        session_resource_type
        session_resource_other
        session_appointment_type
        session_appointment_other
        session_harmredux_type
        session_harmredux_other
        session_documents_type
        session_activity_other
        checkin_naloxone
        checkin_overdose
        checkin_overdose_count
        checkin_overdose_date
        checkin_manic
        checkin_manic_count
        checkin_manic_date
        checkin_stroke
        checkin_stroke_count
        checkin_stroke_date
        checkin_ed_visit
        checkin_ed_visit_count
        checkin_ed_date
        checkin_infection
        checkin_infection_date
        update_tx_rs
        domain_1
        goal_1
        action_activity_1
        action_date_1
        action_status_1
        domain_2
        goal_2
        action_activity_2
        action_date_2
        action_status_2
        domain_3
        goal_3
        action_activity_3
        action_date_3
        action_status_3
        domain_4
        goal_4
        action_activity_4
        action_date_4
        action_status_4
        domain_5
        goal_5
        action_activity_5
        action_date_5
        action_status_5
        domain_6
        goal_6
        action_activity_6
        action_date_6
        action_status_6
        domain_7
        goal_7
        action_activity_7
        action_date_7
        action_status_7
        domain_8
        goal_8
        action_activity_8
        action_date_8
        action_status_8
        domain_9
        goal_9
        action_activity_9
        action_date_9
        action_status_9
        domain_10
        goal_10
        action_activity_10
        action_date_10
        action_status_10
        domain_11
        goal_11
        action_activity_11
        action_date_11
        action_status_11
        domain_12
        goal_12
        action_activity_12
        action_date_12
        action_status_12
        domain_13
        goal_13
        action_activity_13
        action_date_13
        action_status_13
        domain_14
        goal_14
        action_activity_14
        action_date_14
        action_status_14
        domain_15
        goal_15
        action_activity_15
        action_date_15
        action_status_15
        peercm_consent
        gpra_intake_date
        gpra_intake_date_6month
        incentivegroup
        incentivegroup_change
        incentivegroup_change_date
        incentivegroup_change_date_end
        incentive_1
        incentive_1date
        incentive_1peer
        incentive_2
        incentive_2date
        incentive_2peer
        incentive_3
        incentive_3date
        incentive_3peer
        incentive_4
        incentive_4date
        incentive_4peer
        incentive_5
        incentive_5date
        incentive_5peer
        incentive_6
        incentive_6date
        incentive_6peer
        incentive_7
        incentive_7date
        incentive_7peer
        incentive_8
        incentive_8date
        incentive_8peer
        incentive_9
        incentive_9date
        incentive_9peer
        incentive_10
        incentive_10date
        incentive_10peer
        incentive_11
        incentive_11date
        incentive_11peer
        incentive_12
        incentive_12date
        incentive_12peer
        incentive_13
        incentive_13date
        incentive_13peer
        incentive_14
        incentive_14date
        incentive_14peer
        incentive_15
        incentive_15date
        incentive_15peer
        activity1_incentive
        activity1_dom
        activity1_goal
        activity1_action
        activity1_date_act
        activity1_date_incent
        activity1_peer
        activity2_incentive
        activity2_dom
        activity2_goal
        activity2_action
        activity2_date_act
        activity2_date_incent
        activity2_peer
        activity3_incentive
        activity3_dom
        activity3_goal
        activity3_action
        activity3_date_act
        activity3_date_incent
        activity3_peer
        activity4_incentive
        activity4_dom
        activity4_goal
        activity4_action
        activity4_date_act
        activity4_date_incent
        activity4_peer
        activity5_incentive
        activity5_dom
        activity5_goal
        activity5_action
        activity5_date_act
        activity5_date_incent
        activity5_peer
        activity6_incentive
        activity6_dom
        activity6_goal
        activity6_action
        activity6_date_act
        activity6_date_incent
        activity6_peer
        activity7_incentive
        activity7_dom
        activity7_goal
        activity7_action
        activity7_date_act
        activity7_date_incent
        activity7_peer
        activity8_incentive
        activity8_dom
        activity8_goal
        activity8_action
        activity8_date_act
        activity8_date_incent
        activity8_peer
        activity9_incentive
        activity9_dom
        activity9_goal
        activity9_action
        activity9_date_act
        activity9_date_incent
        activity9_peer
        activity10_incentive
        activity10_dom
        activity10_goal
        activity10_action
        activity10_date_act
        activity10_date_incent
        activity10_peer
        has_hepc
        HCV_test_rapid
        hep_test_c_date
        HCV_test_rapid_result
        HCV_test_RNA
        hep_test_hcv_rna_date
        HCV_test_RNA_result
        HCV_tx_link
        HCV_tx_start
        hep_hcv_medication_date
        HCV_tx_complete
        HCV_post_tx_test
        HCV_post_tx_test_result
        hep_ab_services
        report_date
      }
    }
  }
`

export const PRIME_GPRA_REPORT = gql`
  query ReportPrimeGPRAReport($organization_name: String!, $columns: [String!]) {
    ReportPrimeGPRAReport(organization_name: $organization_name, columns: $columns) {
      jobId
      reportName
      isAsync
      results {
        organization_name
        gpra_id
        ClientID
        InterviewType
        GPRA_Interview_Date
        CompletedInterview
        Follow_up_available
        Follow_up_due
        Follow_up_closes
        zipcode
        FentanylMethDays
        FentanylMethSmoked
        FentanylMethInjected
        FentanylMethSwallowed
        FentanylMethSnorted
        FentanylMethOther
        FentanylCocaineDays
        FentanylCocaineSmoked
        FentanylCocaineInjected
        FentanylCocaineSwallowed
        FentanylCocaineSnorted
        FentanylCocaineOther
        HeroinMethDays
        HeroinMethSmoked
        HeroinMethInjected
        HeroinMethSwallowed
        HeroinMethSnorted
        HeroinMethOther
        HeroinCocaineDays
        HeroinCocaineSmoked
        HeroinCocaineInjected
        HeroinCocaineSwallowed
        HeroinCocaineSnorted
        HeroinCocaineOther
        OpioidsFentanylDays
        OpioidsFentanylSmoked
        OpioidsFentanylInjected
        OpioidsFentanylSwallowed
        OpioidsFentanylSnorted
        OpioidsFentanylOther
        OpioidsHeroinDays
        OpioidsHeroinSmoked
        OpioidsHeroinInjected
        OpioidsHeroinSwallowed
        OpioidsHeroinSnorted
        OpioidsHeroinOther
        OpioidPillsDays
        OpioidPillsSmoked
        OpioidPillsInjected
        OpioidPillsSwallowed
        OpioidPillsSnorted
        OpioidPillsOther
        MethadoneBupDays
        MethadoneBupSmoked
        MethadoneBupInjected
        MethadoneBupSwallowed
        MethadoneBupSnorted
        MethadoneBupOther
        MethamDays
        MethamSmoked
        MethamInjected
        MethamSwallowed
        MethamSnorted
        MethamOther
        CrackDays
        CrackSmoked
        CrackInjected
        CrackSwallowed
        CrackSnorted
        CrackOther
        CocaineDays
        CocaineSmoked
        CocaineInjected
        CocaineSwallowed
        CocaineSnorted
        CocaineOther
        RxStimsDays
        RxStimsSmoked
        RxStimsInjected
        RxStimsSwallowed
        RxStimsSnorted
        RxStimsOther
        OtherTranqDays
        OtherTranqSmoked
        OtherTranqInjected
        OtherTranqSwallowed
        OtherTranqSnorted
        OtherTranqOther
        AnxioBenzoDays
        AnxioBenzoSmoked
        AnxioBenzoInjected
        AnxioBenzoSwallowed
        AnxioBenzoSnorted
        AnxioBenzoOther
        HallucinogensDays
        HallucinogensSmoked
        HallucinogensInjected
        HallucinogensSwallowed
        HallucinogensSnorted
        HallucinogensOther
        MarijuanaDays
        MarijuanaSmoked
        MarijuanaInjected
        MarijuanaSwallowed
        MarijuanaSnorted
        MarijuanaOther
        AlcoholDays
        AlcoholSmoked
        AlcoholInjected
        AlcoholSwallowed
        AlcoholSnorted
        AlcoholOther
        Injection
        Injection_age
        Injection_days
        Injected_days_used_syringe
        Injected_days_used_cooker
        Abcess
        SSP_access
        Harm_redux_supplies
        Harm_redux_test_strips
        Syringe_location
        Pipe_location
        no_ssp_reason
        has_naloxone
        trained_naloxone
        used_naloxone
        days_naloxone_avail
        days_naloxone_person_avail
        days_person_present
        days_person_virtual
        days_tester_dose
        drug_check_method
        drug_check_test_strip
        drug_check_days
        believe_oud
        med_oud
        OpMedMethadoneDays
        OpMedBuprenorphineDays
        OpMedNaltrexoneDays
        OpMedExtRelNaltrexoneDays
        believe_stim
        intervention_stim
        StimDisContingMgmtDays
        StimDisCommReinfDays
        StimDisCBTDays
        StimDisOtherEBIDays
        TxSUD
        TxSUDWhen
        overdose
        overdose_count
        overdose_date
        overdose_recovery
        overdose_symptoms
        naloxone_times
        manic
        manic_count
        manic_date
        stroke
        stroke_count
        stroke_date
        overamp_count
        overamp_change
        overamp_change_break
        overamp_change_other
        overamp_emergency
        overdose_intervention
        ed_visit_count
        ed_visit_last_time
        LivingWhere
        LivingHoused
        LivingHousedSpec
        money_source
        EmployStatus
        EmployStatusSpec
        educ_level
        PolContact
        ArrestedDays
        jail_nights
        probation
        Depression
        Anxiety
        Hallucinations
        BrainFunction
        ViolentBehavior
        Suicide
        PsycholEmotMedication
        PsycholEmotImpact
        ReceivedMedCare
        HIV_test
        HIV_test_positive
        HIV_test_meds
        HIV_prep
        HepC_test
        HepC_test_positive
        HepC_test_tx
        AttendVoluntary
        AttendVoluntaryTimes
        InteractFamilyFriends
        FLWPClientContacted
        FLWPStatus
        FLWPStatusSpec
        ReceivingServices
        report_date
      }
    }
  }
`
//New PRIME ends

export const KIOSK_ACTIVITY_REPORT = gql`
  query ReportKioskActivityReport(
    $organization_name: String!
    $start_date: String!
    $end_date: String!
    $locations: String!
    $columns: [String!]
  ) {
    ReportKioskActivityReport(
      organization_name: $organization_name
      start_date: $start_date
      end_date: $end_date
      locations: $locations
      columns: $columns
    ) {
      jobId
      reportName
      isAsync
      results {
        enterprise_name
        kiosk_activity_id
        organization_alias
        organization_name
        kiosk_location
        participant_alias
        participant_membership_id
        participant_name_first
        participant_name_last
        participant_email_account
        participant_phone_primary
        participant_membership_status
        participant_intake_date
        participant_dob
        participant_gender
        participant_county_primary
        participant_assigned_programs
        activity_date
        activity_time
        multi_checkin
        activity_type
        activity_subtype_1
        activity_subtype_2
        activity_other
        report_date
      }
    }
  }
`

export const KIOSK_CONSENT_REPORT = gql`
  query ReportKioskConsentReport($organization_name: String!, $columns: [String!]) {
    ReportKioskConsentReport(organization_name: $organization_name, columns: $columns) {
      jobId
      reportName
      isAsync
      results {
        enterprise_name
        organization_alias
        organization_name
        location_name
        participant_alias
        participant_membership_id
        participant_membership_status
        participant_intake_date
        participant_name_first
        participant_name_last
        participant_address
        participant_city
        participant_state
        participant_zip_code
        participant_email_account
        participant_email_secondary
        participant_phone_primary
        participant_phone_preferences
        activity_date_last
        report_date
      }
    }
  }
`
export const REFERRALS_REPORT = gql`
  query ReportReferralsReport(
    $organization_name: String!
    $location_id: String!
    $program_id: String!
    $start_date: String!
    $end_date: String!
    $staff: String!
    $facilitating_staff: String!
    $status: String!
    $columns: [String!]
  ) {
    ReportReferralsReport(
      organization_name: $organization_name
      location_id: $location_id
      program_id: $program_id
      start_date: $start_date
      end_date: $end_date
      staff: $staff
      facilitating_staff: $facilitating_staff
      status: $status
      columns: $columns
    ) {
      jobId
      reportName
      isAsync
      results {
        enterprise_id
        enterprise_name
        session_uid
        organization_alias_id
        organization_name
        organization_location
        program_id
        facilitating_staff_alias_id
        facilitating_staff_name_first
        facilitating_staff_name_last
        participant_alias_id
        participant_membership_id
        participant_membership_status
        external_id
        participant_name_first
        participant_name_last
        participant_email_account
        participant_dob
        age
        participant_race
        participant_hispanic_ethnicity
        participant_gender
        assigned_staff_id
        assigned_staff_name_first
        assigned_staff_name_last
        fee_service
        participant_ssn
        insurance_current
        insurance_name
        insurance_id
        session_type
        session_date
        session_start_time
        session_end_time
        session_length
        session_units
        session_channel
        referral_type
        referral_type_other
        referral_taxonomy_service
        referral_taxonomy_service_other
        referral_status
        last_staff_update
        referral_partner_status
        last_partner_update
        referral_entity_id
        referral_entity_name
        referral_entity_status
        referral_country
        referral_address
        referral_city
        referral_state
        referral_zip_code
        referral_phone
        referral_reason
        referral_notes
        referral_participants_notes
        referral_rating_value
        referral_rating
        referral_rating_note
        referral_notified
        referral_notified_name
        referral_notified_email
        referral_notified_phone
        referral_appointment
        referral_appointment_date
        referral_appointment_time
        referral_appointment_contact
        date_notified
        report_date
      }
    }
  }
`

export const BARC10_MONTHLY_REPORT = gql`
  query ReportBarc10MonthlyReport($organization_name: String!, $columns: [String!]) {
    ReportBarc10MonthlyReport(organization_name: $organization_name, columns: $columns) {
      jobId
      reportName
      isAsync
      results {
        enterprise_name
        organization_name
        organization_alias_id
        total_assessment_count
        average_assessment_score
        report_date
        organization_id
        report_month
        last_refresh_datetime
      }
    }
  }
`

export const BARC10_INDIVIDUAL_REPORT = gql`
  query ReportBarc10IndividualReport(
    $organization_name: String!
    $location_id: String!
    $program_id: String!
    $start_date: String!
    $end_date: String!
    $staff: String!
    $facilitating_staff: String!
    $status: String!
    $columns: [String!]
  ) {
    ReportBarc10IndividualReport(
      organization_name: $organization_name
      location_id: $location_id
      program_id: $program_id
      start_date: $start_date
      end_date: $end_date
      staff: $staff
      facilitating_staff: $facilitating_staff
      status: $status
      columns: $columns
    ) {
      jobId
      reportName
      isAsync
      results {
        enterprise_name
        session_id
        participant_alias_id
        participant_membership_id
        facilitating_staff_alias_id
        facilitating_staff_name_first
        facilitating_staff_name_last
        facilitating_staff_name
        organization_alias_id
        organization_name
        participant_assigned_locations
        participant_assigned_programs
        session_location
        external_id
        program_id
        session_program_ids
        participant_name_first
        participant_name_last
        participant_email_account
        participant_phone_primary
        participant_birthdate
        age
        participant_membership_status
        participant_intake_date
        participant_last_engagement
        participant_race
        participant_hispanic_ethnicity
        participant_gender
        participant_address
        participant_city
        participant_state
        participant_zipcode
        participant_county_primary
        assigned_staff_id
        assigned_staff_name_first
        assigned_staff_name_last
        fee_service
        participant_ssn
        session_date
        session_type
        session_start_time
        session_end_time
        session_length
        session_units
        session_channel
        contact_successful
        insurance_current
        insurance_name
        insurance_id
        assessment_type
        assessment_name
        assessment_score
        assessment_score_avg
        assessment_score_baseline
        assessment_score_last
        previous_positive_increase
        previous_negative_decrease
        baseline_positive_increase
        baseline_negative_decrease
        date_last_updated
        report_date
      }
    }
  }
`

export const TELERECOVERY_SESSIONS_REPORT = gql`
  query ReportTelerecoverySessionsReport(
    $organization_name: String!
    $location_id: String!
    $program_id: String!
    $start_date: String!
    $end_date: String!
    $staff: String!
    $facilitating_staff: String!
    $status: String!
    $columns: [String!]
  ) {
    ReportTelerecoverySessionsReport(
      organization_name: $organization_name
      location_id: $location_id
      program_id: $program_id
      start_date: $start_date
      end_date: $end_date
      staff: $staff
      facilitating_staff: $facilitating_staff
      status: $status
      columns: $columns
    ) {
      jobId
      reportName
      isAsync
      results {
        enterprise_name
        session_id
        participant_id
        participant_alias_id
        participant_membership_id
        facilitating_staff_id
        facilitating_staff_alias_id
        facilitating_staff_name_first
        facilitating_staff_name_last
        facilitating_staff_name
        organization_alias_id
        organization_name
        organization_location
        session_location
        external_id
        program_id
        session_program_ids
        participant_name_first
        participant_name_last
        participant_email_account
        participant_phone_primary
        participant_birthdate
        age
        participant_membership_status
        participant_intake_date
        participant_last_engagement
        participant_race
        participant_hispanic_ethnicity
        participant_gender
        participant_address
        participant_city
        participant_state
        participant_zipcode
        participant_county_primary
        assigned_staff_id
        assigned_staff_name_first
        assigned_staff_name_last
        fee_service
        participant_ssn
        session_date
        session_start_time
        session_end_time
        session_length_seconds
        session_length
        session_units
        session_channel
        contact_successful
        insurance_current
        insurance_name
        insurance_id
        session_type
        sms_message_count
        chat_message_count
        video_provider
        report_date
      }
    }
  }
`


export const PARTICIPANT_COLUMN = gql`
  query ReportParticipantColumns($table_name: String!) {
    ReportParticipantColumns(table_name: $table_name) {
      column_name
    }
  }
`

export const PARTICIPANT_CONTACT_REPORT = gql`
  query ReportParticipantContactReport($organization_name: String!, $location_names: [String!], $program_names: [String!], $participant_statuses: [String!], $assigned_staff_names: [String!], $columns: [String!]) {
    ReportParticipantContactReport(organization_name: $organization_name, location_names: $location_names, program_names: $program_names, participant_statuses: $participant_statuses, assigned_staff_names: $assigned_staff_names, columns: $columns) {
      jobId
      reportName
      isAsync
      results {
        organization_name
        stamp_id
        enterprise_id
        enterprise_alias
        organization_id
        organization_alias
        participant_id
        participant_alias
        participant_membership_id
        participant_name_first
        participant_name_last
        participant_email_account
        participant_external_id
        participant_membership_status
        facilitating_staff_id
        facilitating_staff_alias
        facilitating_staff_alias_id
        facilitating_staff_name_first
        facilitating_staff_name_last
        facilitating_staff_name
        assigned_staff_id
        assigned_staff_name_first
        assigned_staff_name_last
        assigned_staff_name
        participant_assigned_programs
        participant_assigned_locations
        staff_id
        staff_alias
        template_name
        block_name
        participant_name_preferred
        participant_pronouns
        participant_pronouns_other
        participant_street_address_primary
        participant_city_primary
        participant_state_primary
        participant_zip_code_primary
        participant_address_lives_primary
        participant_address_lives_primary_length
        participant_address_owner_primary
        participant_street_address_secondary
        participant_city_secondary
        participant_state_secondary
        participant_zip_code_secondary
        participant_address_lives_secondary
        participant_address_lives_secondary_length
        participant_address_owner_secondary
        participant_address_none
        participant_county_primary
        participant_email_secondary
        participant_phone_primary
        participant_phone_primary_preference
        participant_phone_primary_none
        participant_phone_secondary
        participant_phone_secondary_preference
        participant_preferred_contact
        participant_preferred_contact_other
        last_intake_date
        last_engagement_date
        date_created
        last_activity
      }
    }
  }
`

export const PARTICIPANT_DEMOGRAPHICS_REPORT = gql`
  query ReportParticipantDemographicsReport($organization_name: String!, $location_names: [String!], $program_names: [String!], $participant_statuses: [String!], $assigned_staff_names: [String!], $columns: [String!]) {
    ReportParticipantDemographicsReport(organization_name: $organization_name, location_names: $location_names, program_names: $program_names, participant_statuses: $participant_statuses, assigned_staff_names: $assigned_staff_names, columns: $columns) {
      jobId
      reportName
      isAsync
      results {
        organization_name
        stamp_id
        enterprise_id
        enterprise_alias
        organization_id
        organization_alias
        participant_id
        participant_alias
        participant_membership_id
        participant_name_first
        participant_name_last
        participant_email_account
        participant_external_id
        participant_membership_status
        facilitating_staff_id
        facilitating_staff_alias
        facilitating_staff_alias_id
        facilitating_staff_name_first
        facilitating_staff_name_last
        facilitating_staff_name
        assigned_staff_id
        assigned_staff_name_first
        assigned_staff_name_last
        assigned_staff_name
        participant_assigned_programs
        participant_assigned_locations
        staff_id
        staff_alias
        template_name
        block_name
        demo_birthdate
        demo_ssn
        demo_gender
        demo_race
        demo_ethnicity
        demo_sexual_orientation
        demo_relationship_status
        veteran_status
        student_status
        demo_status_housing
        demo_community_living_days
        demo_status_employment
        demo_worked_days
        demo_education_level
        demo_status_justice
        demo_arrests_count
        demo_involvement_services_court
        demo_transport
        demo_income_level
        demo_income_source
        demo_income_household
        demo_pregnancy
        demo_pregnancy_trimester
        demo_pregnancy_due_date
        demo_pregnancy_postpartum
        demo_children
        demo_children_count
        demo_dependents_count
        demo_family_count
        demo_tanf
        demo_pcp
        demo_fee_for_service
        demo_insurance_coverage
        demo_insurance_name
        demo_insurance_group_id
        demo_auxiliary
        demo_auxiliary_type
        demo_auxiliary_type_other
        demo_wait
        demo_activities_unable
        demo_age
        last_intake_date
        last_engagement_date
        date_created
        last_activity
      }
    }
  }
`

export const PARTICIPANT_ENGAGED_REPORT = gql`
  query ReportParticipantEngagedReport($organization_name: String!, $location_names: [String!], $program_names: [String!], $participant_statuses: [String!], $assigned_staff_names: [String!], $columns: [String!]) {
    ReportParticipantEngagedReport(organization_name: $organization_name, location_names: $location_names, program_names: $program_names, participant_statuses: $participant_statuses, assigned_staff_names: $assigned_staff_names, columns: $columns) {
      jobId
      reportName
      isAsync
      results {
        organization_name
        stamp_id
        enterprise_id
        enterprise_alias
        organization_id
        organization_alias
        participant_id
        participant_alias
        participant_membership_id
        participant_name_first
        participant_name_last
        participant_email_account
        participant_external_id
        participant_membership_status
        facilitating_staff_id
        facilitating_staff_alias
        facilitating_staff_alias_id
        facilitating_staff_name_first
        facilitating_staff_name_last
        facilitating_staff_name
        assigned_staff_id
        assigned_staff_name_first
        assigned_staff_name_last
        assigned_staff_name
        participant_assigned_programs
        participant_assigned_locations
        staff_id
        staff_alias
        template_name
        block_name
        services_peer
        services_resource_referral
        services_prosocial
        services_advocacy
        services_educational
        services_employment
        services_family
        services_naloxone
        services_mutual_aid_meetings
        services_harm_reduction
        services_reentry
        services_other
        services_other_type
        last_intake_date
        last_engagement_date
        date_created
        last_activity
      }
    }
  }
`

export const PARTICIPANT_CHARACTERISTICS_REPORT = gql`
  query ReportParticipantCharacteristicsReport($organization_name: String!, $location_names: [String!], $program_names: [String!], $participant_statuses: [String!], $assigned_staff_names: [String!], $columns: [String!]) {
    ReportParticipantCharacteristicsReport(
      organization_name: $organization_name,
      location_names: $location_names,
      program_names: $program_names,
      participant_statuses: $participant_statuses,
      assigned_staff_names: $assigned_staff_names,
      columns: $columns
    ) {
      jobId
      reportName
      isAsync
      results {
        assigned_staff_id
        assigned_staff_name_first
        assigned_staff_name_last
        assigned_staff_name
        attend_meetings
        attend_meetings_count
        block_name
        engaged_counselor_program
        engaged_medication_prescribed
        engaged_medication_prescribed_other_type
        engaged_medication_provider
        enterprise_alias
        enterprise_id
        facilitating_staff_id
        facilitating_staff_alias
        facilitating_staff_alias_id
        facilitating_staff_name_first
        facilitating_staff_name_last
        facilitating_staff_name
        history_gambling
        history_mh_anxiety
        history_mh_bipolar
        history_mh_depression
        history_mh_eating_disorder
        history_mh_other
        history_mh_schizophrenia
        history_mh_trauma
        history_recovery_residence
        history_su_alc
        history_su_cannabis
        history_su_intravenous
        history_su_nicotine
        history_su_other_opioids
        history_su_other_sub
        history_su_psychedelics
        history_su_rx_opioids
        history_su_stimulants
        medication_use
        medication_use_current
        organization_alias
        organization_id
        overdose_event
        overdose_event_count
        participant_alias
        participant_email_account
        participant_external_id
        participant_id
        participant_membership_id
        participant_membership_status
        participant_name_first
        participant_name_last
        pathway_primary_recovery
        participant_assigned_programs
        participant_assigned_locations
        staff_alias
        staff_id
        stamp_id
        status_mh_recovery
        status_mh_recovery_date
        status_mh_treatment
        status_mh_treatment_episodes
        status_sud_recovery
        status_sud_recovery_date
        status_sud_treatment
        status_sud_treatment_episodes
        template_name
        organization_name
        last_intake_date
        last_engagement_date
        date_created
        last_activity
      }
    }
  }
`

export const NH_MEDICAID_BILLING_REPORT = gql`
  query ReportNhMedicaidBillingReport(
    $organization_name: String!
    $start_date: String!
    $end_date: String!
    $columns: [String!]
  ) {
    ReportNhMedicaidBillingReport(
      organization_name: $organization_name
      start_date: $start_date
      end_date: $end_date
      columns: $columns
    ) {
      jobId
      reportName
      isAsync
      results {
        enterprise_name
        organization_name
        session_location
        session_id
        facilitating_staff_name
        participant_alias
        participant_membership_id
        participant_name_first
        participant_name_last
        demo_birthdate
        demo_ssn
        participant_address
        participant_city
        participant_state
        participant_zipcode
        demo_insurance_coverage
        demo_insurance_group_id
        demo_insurance_name
        secondary_insurance_type
        secondary_insurance_carrier
        secondary_insurance_id
        session_type
        session_date
        session_time_start
        session_time_end
        session_length
        session_units
        session_channel
        contact_successful
        case_notes
        report_date
        fee_service
      }
    }
  }
`
